import { render } from "./DependencyPreview.vue?vue&type=template&id=48339e26&scoped=true"
import script from "./DependencyPreview.vue?vue&type=script&lang=js"
export * from "./DependencyPreview.vue?vue&type=script&lang=js"

import "./DependencyPreview.vue?vue&type=style&index=0&id=48339e26&scoped=true&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48339e26"]])

export default __exports__